// built-in imports
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";

// internal imports
import { Wrapper } from "./contact-form.styles";
import FormControl from "../form-control/form-control.component";

export const contactFormInitialValues = {
  name: "",
  email: "",
  message: "",
};
export const contactFormValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email().required("Email is required"),
  message: Yup.string().required("Message is required"),
});
/** end */

const ContactForm = () => {
  const handleSubmit = (_, { resetForm }) => {
    toast.success("Message is sent successfully");
    setTimeout(() => {
      resetForm();
    }, 500);
  };
  return (
    <Wrapper>
      <Formik
        initialValues={contactFormInitialValues}
        validationSchema={contactFormValidationSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="contact-form">
            <FormControl element="input" type="text" name="name" label="Name" />
            <FormControl
              element="input"
              type="email"
              name="email"
              label="Email"
            />
            <FormControl
              element="textarea"
              type="text"
              name="message"
              label={<FormattedMessage id="message" defaultMessage="Message" />}
            />
            <button type="submit" className="btn">
              <FormattedMessage id="submit" defaultMessage="Submit" />
            </button>
          </Form>
        )}
      </Formik>
    </Wrapper>
  );
};

export default ContactForm;
